export default __webpack_public_path__ + "static/media/Harlot's Stiletto.c81568aa.jpg";